/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboCalculationDetailSchema } from "./comboCalculationDetailSchema.ts";
import { mobileOrderItemCreateSchema } from "./mobileOrderItemCreateSchema.ts";

export const mobileOrderCreateSchema = z.object({
	items: z.array(mobileOrderItemCreateSchema).optional(),
	combos: z.array(comboCalculationDetailSchema).optional(),
	table: z.uuid().nullish(),
	order_type_id: z.uuid().nullish().describe("Внутренний ID выбранного типа заказа (Здесь/С собой)"),
	locator: z.string().max(8).nullish(),
	comment: z.string().max(50).nullish(),
	tab_name: z.string().max(50).nullish(),
	promo_code: z.string().optional(),
});
